module.exports = __webpack_public_path__ + "media/project3.aa9ab6c4.mp4";